import { gql } from '@apollo/client';
export const DASHBOARD_METABASE_FIELDS = gql`
  fragment DashboardMetabaseFields on DashboardMetabaseDto {
    urlIframe
    code
  }
`;